<template>
  <div>
    <section class="page-banner" style="background-image: url(/static/img/tuotibg.png);">
        <div class="container">
            <div class="banner-tip">
                <h2 class="banner-title">师资团队</h2>
                <div class="bread-crumbs">
                  Faculty team
                </div>
            </div>
        </div>
      </section>  
      <!-- <section class="breadcrumb-area breadcrumb-area2">
      <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="breadcrumb-content">
                    <h2 class="breadcrumb__title">对教育怀揣敬畏之心，用爱成就每一位学生</h2>
                     <p class="breadcrumb__meta"><span class="seller-badge">专业师资陪你成长</span></p>
                </div>
            </div>
        </div>
      </div>
    </section> -->
      <section class="blog-area blog-area3">
           
        <div class="container">
            <div class="section-heading">
                <div class="twotip">
                    <img src="/static/img/apps_fill.png" class="courses-showing-icon"/><span class="courses-showing-text">共有{{ intTotal }}位老师</span>
                  </div>
                <div class="search-box">
                    <input type="search" v-model="searchWords" placeholder="输入关键字...">
                    <button type="submit" @click="search()"><img src="/static/img/search-line.png" width="21" height="21"/></button>
                </div>
            </div>
            <div class="row blog-post-wrapper">
                <div class="blog-post-item" v-for="(article,index) in articles" :key="index">
                    
                    <div class="blog-post-img">
                        <img v-if="article.picsrc" :src="`${global.remoteIp}/uploads/${article.picsrc}`" :alt="article.title" class="blog__img">
                    </div><!-- end blog-post-img -->
                    <div class="post-body">
                        <div class="blog-title">
                            <router-link
                                :to="`/views/info/${article.plateid}/${article._id}`"
                                target="_blank"
                                >{{article.title}}</router-link
                                >
                        </div>
                        <div class="teacher">大学教授</div>
                        <div class="heng"></div>
                        <div class="blog-desp">
                            <p>{{article.description}}</p>
                        </div>
                    </div><!-- end post-body -->
                </div><!-- end blog-post-item -->
            </div><!-- end row -->
        </div><!-- end container -->
    </section><!-- end blog-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        global,
        intTotal:20,
        intCurrent:1,
        articles:[],
        plateId: "",
        searchWords:""
    };
  },

  components: {},

  computed: {},

  mounted() {
    let plateId = this.$route.params.plateId;
    this.plateId = plateId;
    this.$axios.get(`/api/articles?plateid=${plateId}&page=${this.intCurrent}&limit=6&sort=-createdAt`).then((res) => {
        if (res.data) {
            this.intTotal =res.data.total;
            this.articles = res.data.data;
        }
    });
  },

  methods: {
      toTop(){
        document.body.scrollTop =0;
        document.documentElement.scrollTop = 0;
      },
      toPage(intcount){
         var searchConditions = '';
          if (this.searchWords) {
            searchConditions += "&title=$regex:" + this.searchWords;
          }
        this.intCurrent = intcount;
        this.$axios.get(`/api/articles?plateid=${this.plateId}&page=${this.intCurrent}&limit=6&sort=-createdAt${searchConditions}`).then((res) => {
            if (res.data) {
                this.intTotal =res.data.total;
                this.articles = res.data.data;
                 this.toTop();
            }
        });
    },
    search() {
      var searchConditions = '';
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      this.$axios.get(`/api/articles?plateid=${this.plateId}&page=${this.intCurrent}&limit=6&sort=-createdAt${searchConditions}`).then((res) => {
        if (res.data) {
          this.intTotal = res.data.total;
          this.articles = res.data.data;
          this.toTop();
        }
      });
    }
  }
}

</script>
<style scoped>

.breadcrumb-area2{
  background: url('/static/images/bg_001.png') repeat-x  top;
  margin:  auto;
  margin-top: 11px;
  width: 1200px;
  height: 270px;
}
.breadcrumb-content{
  margin: 60px 66px;
}
.seller-badge{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
}
.breadcrumb__title{
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
        line-height: 92px;
    text-align: center;
}
.breadcrumb__list{
      font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.breadcrumb__list a{
      font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.breadcrumb__meta{
     text-align: center;
}
.blog-post-wrapper{
    margin-top:39px;
}
.blog-post-img{
    display: inline-block;
}
.blog-post-img img{
  margin-top: 24px;
  margin-left: 44px;
width: 137px;
height: 189px;
background: #2B52B7;
border-radius: 12px;
}
.blog-post-right-img{
    display: inline-block;
    left: 298px;
    position: relative;
}
.blog-post-right-img img{
        width: 298px;
    height: 297px;
}
.post-body{
    display: inline-block;
    width: 399px;
    height: 189px;
    position: absolute;
    padding: 26px;
    padding-left: 35px;
}
.row{
    margin-right: 0px;
    margin-left: 0px;
}
.blog-post-item{
  margin-right: 40px;
  margin-bottom: 40px;
    padding-right: 0px;
    padding-left: 0px;
    width: 580px;
height: 246px;
background: #F9FAFF;
border-radius: 20px;
}
.blog-post-item:nth-child(2n){
  margin-right: 0;
}
.blog-post-item:nth-child(4),.blog-post-item:nth-child(3){
  
background: #EFF8F9;
}
.blog-title{
  padding-top: 20px;
  padding-bottom: 11px;
}
.blog-title a{
height: 20px;
font-size: 20px;
font-family: PingFang SC;
font-weight: 500;
color: #060606;
line-height: 20px;
}
.blog-desp p{
  width: 312px;
  height: 40px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  word-wrap: break-word;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp:2 ;
  overflow: hidden;
}
/* two search */
.section-heading{
  display: flex;
  justify-content: space-between;
}
.twotip {
  padding-left:21px ;
  padding-right: 35px;
  height: 66px;
  background: #4462CF;
  box-shadow: 0px 10px 29px 0px rgba(68, 98, 207, 0.39);
  border-radius: 5px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.search-box input{
  border: 0;
  padding-left:19px;
  padding-right: 12px;;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  width: 235px;
  height: 66px;
  background: #F5F7FF;
}
.search-box input::placeholder{
  color: #B7B7B7;
}
.search-box input[type="search"] {
  height: 66px;
}
.search-box button {
  background: #F5F7FF;
  border: 0;
  height: 66px;
  line-height: 66px;
}
.search-box img{
  margin-top: 0px;
  margin-left: 0px;
}
.search-box button{
  padding: 0 20px;
}
/* two search */
.teacher{
  width: 96px;
height: 30px;
background:#4462CF;
background: linear-gradient(to right,#4462CF 60%, #ffffff 100%);
border-radius: 5px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 30px;
padding-left: 5px;
}
.heng{
  margin-top: 28px;
  margin-bottom: 11px;
  width: 292px;
height: 4px;
background: #4462CF;
border-radius: 2px;
background: linear-gradient(to right,#4462CF 5%, #ffffff 100%);
}
</style>